export default {"src":"/_next/static/media/woman-with-plant.bbd6692f.svg","height":204,"width":263,"blurWidth":0,"blurHeight":0};